export default {"src":"/_next/static/media/initial-vendor-assessment.68638828.svg","height":297,"width":297,"blurWidth":0,"blurHeight":0};